<template>
  <div class="content-area-wrap">
    <el-row class="content-area">
      <el-col :span="24" class="header">
        <el-row>
          <el-col :span="12">功能</el-col>
          <el-col :span="12">快捷键</el-col>
        </el-row>
      </el-col>
      <el-col :span="24" class="content">
        <el-row>
          <el-col :span="24">
            <el-row>
              <el-col :span="12">复制</el-col>
              <el-col :span="12">Ctrl+C</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">剪切</el-col>
              <el-col :span="12">Ctrl+X</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">粘贴</el-col>
              <el-col :span="12">Ctrl+V</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">查找</el-col>
              <el-col :span="12">Ctrl+F</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">上一句</el-col>
              <el-col :span="12">Ctrl+↑</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">下一句</el-col>
              <el-col :span="12">Enter</el-col>
            </el-row>

            <el-row >
              <el-col :span="12">添加术语</el-col>
              <el-col :span="12">Alt+T</el-col>
            </el-row>

            <el-row v-if="false">
              <el-col :span="12">确认候选单词（单词补全）</el-col>
              <el-col :span="12">→</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">句段内全选</el-col>
              <el-col :span="12">Ctrl+A</el-col>
            </el-row>

            <el-row>
              <el-col :span="12">句段内选中单词</el-col>
              <el-col :span="12">Ctrl+Shift+→/←</el-col>
            </el-row>
            <el-row>
              <el-col :span="12">显示右侧菜单</el-col>
              <el-col :span="12">Ctrl+M</el-col>
            </el-row>
            <el-row>
              <el-col :span="12">自动查找待确认并确认</el-col>
              <el-col :span="12">Ctrl</el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="12">添加术语</el-col>
              <el-col :span="12">Ctrl+B</el-col>
            </el-row> -->
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "KeyboardShortcut",
  computed: {
    //获取url参数
    getUrlInfo() {
      const urlInfo = this.$store.getters['editor/getUrlInfo'];
      if (!!urlInfo && !!(urlInfo.type) && ((urlInfo.type) !== 'school')) {
        return true
      } else {
        return false
      }
    },
  }
}
</script>